import { render } from "./EnSkeleton.vue?vue&type=template&id=370fb60e&ts=true"
import script from "./EnSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnSkeleton.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/base/EnSkeleton/EnSkeleton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "370fb60e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('370fb60e', __exports__)) {
    api.reload('370fb60e', __exports__)
  }
  
  module.hot.accept("./EnSkeleton.vue?vue&type=template&id=370fb60e&ts=true", () => {
    api.rerender('370fb60e', render)
  })

}


export default __exports__